import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import getShearingData from "../../../../../helper/getOptimizedShearingInstructions.js";

const ShearingInstructions = ({
  flatSheetSize,
  orderedCuts,
  orderedPieces,
  hideTitle = false,
}) => {
  const [shearingData, setShearingData] = useState(null);

  useEffect(() => {
    if (flatSheetSize && orderedCuts && orderedPieces) {
      let sheardata = getShearingData(
        flatSheetSize,
        orderedCuts,
        orderedPieces
      );
      setShearingData(sheardata);
    }
  }, [flatSheetSize, orderedCuts, orderedPieces]);

  if (shearingData)
    return (
      <Box>
        {shearingData.shearingInstructions &&
          shearingData.shearingInstructions.length > 0 && (
            <Box>
              {!hideTitle && (
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ marginTop: "32px" }}
                >
                  Shearing Instructions
                </Typography>
              )}

              <Box sx={{}}>
                <Grid container spacing={2} sx={{}}>
                  {shearingData.flatSheetsForShearing.map(
                    (flatSheet, index) => {
                      let { title, count, sheetTemplate } = flatSheet;
                      let currentFSUsedWidth = 0;
                      for (let fsPiece of sheetTemplate.pieces) {
                        currentFSUsedWidth += Number(fsPiece.stretchOut);
                      }
                      let drop = flatSheetSize - currentFSUsedWidth;
                      return (
                        <Grid
                          key={sheetTemplate.tempId}
                          item
                          sx={{
                            marginTop: "16px",
                            border: null,
                            background: "inherit",
                            // width: "120px",
                          }}
                          xs={4}
                          sm={3}
                          md={2}
                        >
                          <Typography>{title}</Typography>
                          <Box sx={{ width: "100%" }}>
                            {sheetTemplate.pieces.map((piece, index) => {
                              return (
                                <Box
                                  key={piece.tempId}
                                  sx={{
                                    borderTop: 1,
                                    borderBottom: 1,
                                    // borderLeft: 1,
                                    // borderLeftStyle: "dotted",
                                    // borderRight: 1,
                                    // borderRightStyle: "dotted",
                                    // The times 6.25 is so that the box will have a height of approx 300px (usually the mc width is 48 inches)
                                    // 300px / 48 inches = 6.25px/in
                                    height: `${piece.stretchOut * 6.25}px`,
                                    minHeight: "25px",
                                    width: "100%",
                                    background: "green",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      paddingLeft: "4px",
                                      paddingRight: "4px",
                                      width: "100%",
                                      textAlign: "center",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: "1",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                    inline
                                  >
                                    {piece.stretchOut}" - {piece.name}
                                  </Typography>
                                </Box>
                              );
                            })}
                            {drop > 0 && (
                              <Box
                                sx={{
                                  borderTop: 1,
                                  borderBottom: 1,
                                  // borderLeft: 1,
                                  // borderLeftStyle: "dotted",
                                  // borderRight: 1,
                                  // borderRightStyle: "dotted",
                                  // The times 6.25 is so that the box will have a height of approx 300px (usually the mc width is 48 inches)
                                  // 300px / 48 inches = 6.25px/in
                                  height: `${drop * 6.25}px`,
                                  minHeight: "25px",
                                  width: `100%`,
                                  background: "gray",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography sx={{ fontSize: "12px" }}>
                                  {drop}" Drop
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Grid>
                      );
                    }
                  )}
                </Grid>
                <Box sx={{ marginTop: "16px" }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {shearingData.shearingInstructions.map(
                      (instruction, index) => {
                        return (
                          <Typography key={index} variant="caption">
                            {index + 1}: {instruction}
                          </Typography>
                        );
                      }
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
      </Box>
    );
};

export default ShearingInstructions;
